<mat-card>
  <div>
    <div class="counter">
      @if (openTask().open > 0) {
        <span class="color-orange">{{ openTask().open }}</span>
      }

      @if (openTask().open <= openTask().total) {
        @if (openTask().open > 0) {
          <span class="color-gray slash">/</span>
        }
        <span class="color-gray">{{ openTask().total }}</span>
      }
    </div>
    <div class="header">
      {{ label() }}
    </div>

    <div class="subheader" [class.active]="openTask().open === 0">
      {{ openTask().open > 0 ? 'zuordnen' : 'zugeordnet' }}
    </div>
  </div>

  <div class="icon-wrapper">
    <mat-icon class="material-icons-outlined factory-icon">{{ icon() }}</mat-icon>
  </div>
</mat-card>
